var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperClipOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1146 4.66667L5.72393 9.05733C5.59659 9.18033 5.49501 9.32746 5.42513 9.49013C5.35525 9.6528 5.31847 9.82776 5.31693 10.0048C5.31539 10.1818 5.34913 10.3574 5.41617 10.5213C5.48321 10.6851 5.58221 10.834 5.70741 10.9592C5.8326 11.0844 5.98146 11.1834 6.14533 11.2504C6.30919 11.3175 6.48476 11.3512 6.6618 11.3497C6.83884 11.3481 7.0138 11.3113 7.17647 11.2415C7.33914 11.1716 7.48627 11.07 7.60927 10.9427L11.8853 6.552C12.371 6.04906 12.6398 5.37545 12.6337 4.67626C12.6277 3.97707 12.3472 3.30824 11.8528 2.81382C11.3584 2.3194 10.6895 2.03894 9.99034 2.03287C9.29114 2.02679 8.61754 2.29558 8.1146 2.78133L3.83793 7.17133C3.08772 7.92154 2.66626 8.93904 2.66626 10C2.66626 11.061 3.08772 12.0785 3.83793 12.8287C4.58814 13.5789 5.60564 14.0003 6.6666 14.0003C7.72755 14.0003 8.74506 13.5789 9.49527 12.8287L13.6666 8.66667",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperClipOutline);
export default __webpack_public_path__ + "static/media/PaperClipOutline.80a8652fcd3bc5746721ca7d32d6a628.svg";
export { ForwardRef as ReactComponent };